import { ModalProps } from "antd/lib/modal/Modal";
import { Button, Col, Input, message, Modal, Row, Table } from "antd";
import styles from "./index.module.scss";
import React, { useContext, useMemo, useState } from "react";

import { ColumnProps } from "antd/lib/table/interface";
import { overFlow } from "../../../../../../components/overFlow";
import useRequest from "../../../../../../utils/useRequest";
import { NoWeekTimeCourse } from "../../../../../../service/course";
import useSelection from "../../../../../../utils/v2/useSelection";
import useRequestFn from "../../../../../../utils/useRequestFn";
import {
    copyChapterTree,
    getApplyCourse,
    GetApplyProps
} from "../../../../../../service/CourseDetail/chapter";
import { ResultMessage } from "../../../../../../components/ResultMessage";
import { errorMessage } from "../../../../../../service/service";
import { CourseContext } from "../../../../Store";
import Form from "rc-field-form";
import LocalBatchPicker from "../../../../../../components/LocalBatchPicker";
import Storage from "utils/Storage";
import Config from "../../../../../../config";
import useCurrentDate from "../../../../../../utils/useCurrentDate";

interface DataModalInstance {
    setPayload: (payload: any) => void;
}

interface DataModalProps extends ModalProps {
    onOk?: () => void;
    onCancel?: () => void;
}

const ApplyModal = React.forwardRef<DataModalInstance, DataModalProps>(
    ({ onOk, onCancel, ...props }, ref) => {
        const { batchNo } = useCurrentDate();

        const [query, setQuery] = useState<GetApplyProps>({
            keywords: "",
            batchNo: Storage.get("batch") || Config.DefaultBatch
        });

        const [data, { loading: tableLoading }] = useRequest(
            () => getApplyCourse({ ...query }),
            {},
            [query]
        );

        const rowSelection = useSelection();

        function onFinish(data: GetApplyProps) {
            setQuery(query => ({ ...query, ...data }));
        }

        const tableData = useMemo(() => {
            return data?.map(item => {
                return {
                    ...item,
                    key: `${item.batchNo}-${item.courseNo}-${item.courseSeq}`
                };
            });
        }, [data]);

        const columns: ColumnProps<NoWeekTimeCourse>[] = [
            {
                title: "课程编号",
                dataIndex: "courseNo",
                width: 150
            },
            {
                title: "课程序号",
                dataIndex: "courseSeq",
                width: 100
            },
            {
                title: "课程名称",
                dataIndex: "courseName",
                render: (text: string) => overFlow(text)
            }
        ];

        const [applyAction, { loading: applyLoading }] =
            useRequestFn(copyChapterTree);

        const { course } = useContext(CourseContext);

        async function submit() {
            try {
                const newBatchNo: string[] = [];
                const newCourseNo: string[] = [];
                const newCourseSeq: string[] = [];

                rowSelection.selected.forEach(item => {
                    const [batch, no, seq] = item.toString().split("-");
                    newBatchNo.push(batch);
                    newCourseNo.push(no);
                    newCourseSeq.push(seq);
                });

                await applyAction({
                    newBatchNo: newBatchNo.join(","),
                    newCourseNo: newCourseNo.join(","),
                    newCourseSeq: newCourseSeq.join(","),
                    oldBatchNo: batchNo,
                    oldCourseNo: course.courseNo,
                    oldCourseSeq: course.courseSeq
                });
                await onOk?.();
                message.success("应用成功");
            } catch (e) {
                ResultMessage.error(errorMessage(e));
            }
        }

        return (
            <Modal
                {...props}
                className={styles.root}
                onCancel={onCancel}
                maskClosable={false}
                title="应用到其他课程"
                okButtonProps={{
                    disabled: rowSelection.selected.length === 0,
                    loading: applyLoading || tableLoading
                }}
                onOk={submit}>
                <Form style={{ marginBottom: 15 }} onFinish={onFinish}>
                    <Row type="flex" justify="end" align="middle" gutter={15}>
                        <Col span={10}>
                            <LocalBatchPicker
                                value={query.batchNo}
                                onChange={batchNo =>
                                    setQuery({ ...query, batchNo })
                                }
                            />
                        </Col>

                        <Col span={10}>
                            <Form.Field name="keywords" initialValue="">
                                <Input placeholder="请输入课程名称，编号或序号" />
                            </Form.Field>
                        </Col>
                        <Col>
                            <Button type="primary" htmlType="submit">
                                搜索
                            </Button>
                        </Col>
                    </Row>
                </Form>
                <Table
                    loading={tableLoading}
                    rowKey="key"
                    rowSelection={rowSelection}
                    dataSource={tableData || []}
                    columns={columns}
                    scroll={{ y: "60vh" }}
                />
            </Modal>
        );
    }
);

ApplyModal.displayName = "ApplyModal";
export default ApplyModal;
